import { Grid } from "@mui/material";
import React from "react";

function Height({ ...props }) {
  return (
    <Grid style={{ height: props.val }} className={props.className}></Grid>
  );
}

export default Height;
